import { Component, Input } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, BaseEntity, CredentialExternalInfo } from '@m4u-angular/base/entities/BaseEntities';
import { LoginEndpoint } from '@m4u-angular/core/endpoints/login.endpoint';
import { EnumLanguages, EnumNotificationDeliveryOptions, EnumPageDisplayModes, EnumPageEntitySources, EnumSystemOptions }
    from '@m4u-angular/core/framework/sysenums.enum';
import { SysGlobals } from '@m4u-angular/core/framework/sysglobals';
import { Utils } from '@m4u-angular/core/helpers/Utils';

class State extends BaseState {
    DeliveryOptions: any[];
    DeliveryOption: EnumNotificationDeliveryOptions;
    Language: EnumLanguages;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-welcome-user-dialog',
    templateUrl: './welcome-user-dialog.component.html',
    styleUrls: ['./welcome-user-dialog.component.scss']
})
export class WelcomeUserDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() CredentialID: number;
    @Input() CredentialInfo: CredentialExternalInfo;

    constructor(A: ServiceBagService,
        private loginEndpoint: LoginEndpoint) {
        super(A, 'WelcomeUserDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    override OnInitState() {
        this.State.Language = SysGlobals.Language as EnumLanguages;
        this.State.DeliveryOptions = this.LIST('NotificationDeliveryOptions').filter(x => {
            switch (x.Value) {
                case EnumNotificationDeliveryOptions.Email:
                    return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodEmail) && this.CredentialInfo.Email;
                case EnumNotificationDeliveryOptions.SMS:
                    return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodSMS) && this.CredentialInfo.Phone;
                case EnumNotificationDeliveryOptions.WhatsApp:
                    return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodWhatsApp) && this.CredentialInfo.Phone;
                default:
                    break;
            }
            return false;
        });
        if (this.State.DeliveryOptions.length > 0) this.State.DeliveryOption = this.State.DeliveryOptions[0].Value;
    }

    WelcomeUser() {
        const address = this.State.DeliveryOption == EnumNotificationDeliveryOptions.Email ?
            this.CredentialInfo.Email : this.CredentialInfo.Phone;
        this.Do(this.loginEndpoint.WelcomeUser(+this.CredentialID, this.State.DeliveryOption, address, this.State.Language), true, () => {
            this.CloseDialogWithSuccess();
        });
    }
}
